var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Status Track",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1400px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', [_c('el-form', {
    staticClass: "el-form-filter",
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.getDataList(1);
      }
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "value-format": "timestamp",
      "type": "daterange",
      "range-separator": "~",
      "start-placeholder": "Start Date",
      "end-placeholder": "Ending Date"
    },
    on: {
      "change": function change($event) {
        return _vm.getDataList(1);
      }
    },
    model: {
      value: _vm.watchStartToEndSecondTimeRange,
      callback: function callback($$v) {
        _vm.watchStartToEndSecondTimeRange = $$v;
      },
      expression: "watchStartToEndSecondTimeRange"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mt20 pb20"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createAt",
      "align": "center",
      "label": "Handling Time",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("parseTimeSecond")(scope.row.createAt)) + " ")];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "clientCode",
      "align": "center",
      "label": "Client code",
      "width": "100"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "country",
      "align": "center",
      "label": "Country"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Status",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.clientCodeStatusFormat(scope.row.status)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Introduced By",
      "width": "126"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.introducedByFormat(scope.row.introducedBy)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Commission",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm._l(scope.row.commissionList, function (item) {
          return _c('p', {
            key: "commission".concat(item.id),
            staticClass: "mt0 mb0"
          }, [_vm._v(" " + _vm._s(item.name) + " - " + _vm._s(_vm._f("percentage")(item.commissionRate)) + " "), item.remark ? _c('el-popover', {
            attrs: {
              "placement": "bottom",
              "trigger": "hover"
            }
          }, [_c('div', {
            staticClass: "fs12 lh20 enbr",
            staticStyle: {
              "max-width": "300px"
            }
          }, [_vm._v(_vm._s(item.remark))]), _c('span', {
            staticClass: "fs14 lightGray el-icon-info",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          })]) : _vm._e()], 1);
        });
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "introducer",
      "align": "center",
      "label": "Introducer",
      "min-width": "120"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Handler"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.userInfo.nickname))])];
      }
    }])
  })], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }